import { useCallback } from 'react';

import { setItem } from '@/store/ServerStorage';

import { THEME_PREFERENCE_KEY } from './colorMode.constants';
import type { ResolvedTheme, ThemePreference } from './colorMode.constants';
import {
  useResolvedTheme,
  useThemePreferenceValue,
  useThemeStore,
} from './themeStore';

interface UseThemePreferenceResult {
  preference: ThemePreference;
  resolvedTheme: ResolvedTheme;
  setPreference: (preference: ThemePreference) => void;
}

/**
 * The user's theme choice. Setting it updates the page at once (via the
 * store, which `ThemeSync` applies to `<html>`) and persists it to the
 * server-side user preferences so it follows them across devices.
 */
export const useThemePreference = (): UseThemePreferenceResult => {
  const preference = useThemePreferenceValue();
  const resolvedTheme = useResolvedTheme();

  const setPreference = useCallback((next: ThemePreference) => {
    useThemeStore.getState().setPreference(next);
    setItem(THEME_PREFERENCE_KEY, next);
  }, []);

  return { preference, resolvedTheme, setPreference };
};
